import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=4fbb6b80"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&id=4fbb6b80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports